import { render } from "./FikirlerView.vue?vue&type=template&id=23abbcb5"
import script from "./FikirlerView.vue?vue&type=script&lang=js"
export * from "./FikirlerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__